import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/api/agendas';

export default {
	/*
		Get list
	*/
	getList(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get guest list
	*/
	getGuestList(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/guests?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get list by event slug
	*/
	listByEventSlug(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/list_by_event_slug?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get active agenda
	*/
	getActiveAgenda(params, cb, errorCb) {
		const url = `${endpoint}/${params.event_id}/active`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get details
	*/
	getDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get details by slug
	*/
	getDetailsBySlug(slug, cb, errorCb) {
		const url = `${endpoint}/${slug}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get details raw data by slug
	*/
	getDetailsBySlugRaw(slug, params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/${slug}/raw?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Create
	*/
	create(params, cb, errorCb) {
		const url = endpoint;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Create bulk
	*/
	bulkCreate(params, cb, errorCb) {
		const url = `${endpoint}/bulk_create`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Update
	*/
	update(id, params) {
		const url = `${endpoint}/${id}`;
		return client.put(url, params);
	},

	/*
		Delete - single data
	*/
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.delete(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Bulk delete
	*/
	bulkDelete(ids, cb, errorCb) {
		const params = {
			agenda_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	/*
		Start agenda
	*/
	start(id, cb, errorCb) {
		const url = `${endpoint}/${id}/start`;
		client.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	/*
		Set bookmark
	*/
	bookmark(id) {
		return client.post(`${endpoint}/${id}/bookmark`);
	},

	/*
	 * Reorder
	*/
	reorder(params, cb, errorCb) {
		const url = `${endpoint}/reorder`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Update
	*/
	updateSettings(id, params) {
		const url = `${endpoint}/${id}/settings`;
		return client.put(url, params);
	},

	/*
		Clear index suggestions
	*/
	clearIndex(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/clear_index`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get list
	*/
	exportList(eventId, params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/${eventId}/export?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
